import React from 'react';
import { getGeneralConfig } from '../../utilities/actions/Helpers';
import { general_config } from '../../utilities/actions/Constant';
import ReactHtmlParser from 'react-html-parser';
import { RetrieveRequest } from '../../utilities/services/RequestService';
import { getProfile } from '../../utilities/services/AuthService';
import { api } from '../../config/Services';
import { Spin, Layout, Form } from 'antd';
import Bulk from './bulk/Index';

const { Content } = Layout;
class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			announcement: null,
			isLoading: false,
			partnercode: null
		}
	}

	componentDidMount() {
		document.title = 'Dashboard | Loyalty Management System';
		this.getDetail();

		const callbackShow = (show) => {
			if (show === 'true' || show === true) {
				const callback = (announcement) => {
					this.setState({ announcement });
				}
				getGeneralConfig(general_config.default_announcement_partner, callback);
			}
		}
		getGeneralConfig(general_config.default_announcement_partnershow, callbackShow);
	}

	getDetail = () => {
		let profile = getProfile();
		let username = profile.username;
		let url = api.url.user.user.list;
		let paging = {};
		let criteria = { username };
		let sort = {};
		//call loader
		this.setState({ loading: true });
		RetrieveRequest(url, criteria, sort, paging).then((response) => {
			const { status, result } = response;
			if (status.responsecode === '0000' && result) {
				if (result.length !== 0) {
					let partnercode = (result[0].partnercode) ? result[0].partnercode : '';
					this.setState({ partnercode, loading: false });
				} else {
					this.setState({ responseMessage: 'Data not found', formrender: false });
				}
			} else {
				this.setState({
					responseCode: status.responsecode,
					responseMessage: status.responsemessage,
					formrender: false,
				});
			}
		});
	}

	render() {
		const { isLoading, announcement, partnercode } = this.state;
		return (
			<React.Fragment>
				{ReactHtmlParser(announcement)}
				{partnercode ?
					<Layout style={{ background: '#fff', margin: '0 0px' }}>
						<Content style={{ alignContent: 'center', margin: '16px 0', padding: '36px', background: '#fff' }}>
							<Spin spinning={isLoading}>
								<Bulk />
							</Spin>
						</Content>
					</Layout>
					: ''}
				{/* Halo */}
			</React.Fragment>
		)
	}
}

export default Form.create()(App);